window.Preview = function () {
    var el = this;
    var PREVIEW_WIDTH = 170;
    var PREVIEW_HEIGHT = 60;

    el.templateData = {};

    function generate(workareaId) {
        if (el._parent.hasOwnProperty('product')) {
            var productId = el.product.id;
        }

        var workareas = el.workData.workareas;

        var workarea, templateWorkarea, pos, templateFormat, format;
        workarea = workareas[workareaId];
        
        templateWorkarea = {
            show_preview: false,
            is_active: parseInt(workareaId) === parseInt(el.selectWorkareaId) ? true : false,
            workarea_id: workareaId,
            name: workarea.name
        };
        
        if ($(window).width() < 768) {
            return templateWorkarea;
        }

        pos = {
            width: PREVIEW_WIDTH,
            height: PREVIEW_WIDTH / (workarea.width / workarea.height)
        };

        if (pos.height > PREVIEW_HEIGHT) {
            pos.height = PREVIEW_HEIGHT;
            pos.width = PREVIEW_HEIGHT / (workarea.height / workarea.width);
        }

        templateWorkarea = {
            show_preview: true,
            is_active: parseInt(workareaId) === parseInt(el.selectWorkareaId) ? true : false,
            workarea_id: workareaId,
            width: pos.width,
            height: pos.height,
            source_width: workarea.width,
            source_height: workarea.height,
            name: workarea.name,
            mask: {
                id: productId && el.workarea.workareas[productId][workareaId].mask === '1' ? workareaId : 0
            },
            format: {}
        };
        
        if (productId) {
            var background = el.workarea.workareas[productId][workareaId].background;
            el.templateData.background = {
                is_show: background !== null,
                url: background
            };
        }

        format = workarea.format;

        templateFormat = {
            id: format.id,
            width: format.width,
            height: format.height,
            view_width: el.WORKAREA_WIDTH,
            view_height: parseInt(el.WORKAREA_WIDTH * format.height / format.width),
            x: format.x,
            y: format.y
        };

        // generated backgrounds, cells, texts
        templateFormat.backgrounds = [];
        var i;
        var images = $.extend(true, {}, format.backgrounds);
        var image;
        for (i in images) {
            if (images.hasOwnProperty(i) && images[i] !== null) {
                image = images[i];
                image.id = i;

                switch (image.type) {
                    case 'custom':
                        image.url = window.location.origin + el.projectsPath + '/' + window.bookSid + '/preview/' + image.name;
                        break;
                    case 'theme':
                        image.url = window.location.protocol + '//' + window.location.hostname + '/img/uploaded/souvenir/themes/' + image.company_id + '/' + image.theme_id + '/preview/' + image.name;
                        break;
                    case 'template':
                        image.url = window.location.protocol + '//' + window.location.hostname + '/img/uploaded/souvenir/templates/' + image.theme_id + '/preview/' + image.name;
                        break;
                }
                templateFormat.backgrounds.push(image);
            }
        }

        templateFormat.layers = el.layer.getTemplateLayers(workareaId, 'preview');
        templateFormat.texts = [];
        var i, j, rows, text;
        for (i in format.texts) {
            text = $.extend(true, {}, format.texts[i]);
            rows = $.extend(true, {}, text.rows);
            text.rows = [];

            for (j in rows) {
                text.rows.push(rows[j]);
            }

            templateFormat.texts.push(text);
        }

        //calendar_grids
        templateFormat.calendar_grids = [];
        var i, item, content;

        if (format.hasOwnProperty('calendar_grids')) {

            for (i in format.calendar_grids) {
                item = format.calendar_grids[i];

                content = el.calendarGrid.render(item, item.year.name, item.month.number, i);

                templateFormat.calendar_grids.push({
                    is_selection: el._parent.hasOwnProperty('isTemplater') ? true : false,
                    id: i,
                    x: item.x,
                    y: item.y,
                    width: item.width,
                    height: item.height,
                    mainwidth: item.mainwidth,
                    mainheight: item.mainheight,
                    rotate_angle: item.rotate_angle,
                    rotate_x: item.rotate_x,
                    rotate_y: item.rotate_y,
                    content: content
                });
            }
        }

        templateWorkarea.format = templateFormat;

        return templateWorkarea;
    }

    el.render = function () {
        var workareas = el.workData.workareas;
        var $element = $('#preview-wrapper');

        if (Object.keys(workareas).length <= 1) {
            $element.addClass('hide');
            $element.find('.preview').empty();
            return false;
        }

        el.templateData = {
            color: el._parent.hasOwnProperty('color') ? el.color.current : {},
            workareas: []
        };

        var workareaId, templateWorkarea;
        for (workareaId in workareas) {
            templateWorkarea = generate(workareaId);
            el.templateData.workareas.push(templateWorkarea);
        }

        var output = window.Mustache.render($('#preview-template').html(), el.templateData);
        $element.removeClass('hide');
        $element.find('.preview').html(output);
    };

    el.set = function (id) {
        $('.js-set-workarea').removeClass('active');
        $('.js-set-workarea[data-id="' + id + '"]').addClass('active');
    };

    el.update = function () {
        if (Object.keys(el.workData.workareas).length <= 1) {
            return false;
        }

        var workareaId = el.selectWorkareaId;

        el.templateData = {
            color: el.hasOwnProperty('color') ? el.color.current : {},
            workareas: []
        };

        var templateWorkarea = generate(workareaId);
        el.templateData.workareas.push(templateWorkarea);

        var output = window.Mustache.render($('#preview-template').html(), el.templateData);
        $('.js-set-workarea[data-id="' + workareaId + '"]').replaceWith(output);
    };
};